import { Search } from 'lucide-react';
import React from 'react';

import { cn } from '@/lib/utils';
import {
  highlightMatches,
  SearchMatch,
  SearchResults,
} from '@/utils/searchUtils';

interface SearchResultsListProps {
  results: SearchResults;
  onMatchClick: (match: SearchMatch) => void;
  activeMatchIndex: number | null;
}

export const SearchResultsList: React.FC<SearchResultsListProps> = ({
  results,
  onMatchClick,
  activeMatchIndex,
}) => {
  if (results.matches.length === 0) {
    return (
      <div className="text-center py-8 text-gray-500">
        <Search className="w-8 h-8 mx-auto mb-2 text-gray-400" />
        <p className="text-sm">No matches found</p>
      </div>
    );
  }

  return (
    <div className="space-y-2">
      {results.matches.map((match) => (
        <button
          type="button"
          key={match.globalMatchIndex}
          data-match-index={match.globalMatchIndex}
          onClick={() => onMatchClick(match)}
          className={cn(
            'w-full text-left p-2 rounded border transition-all',
            'hover:border-blue-300 hover:bg-blue-50/50',
            activeMatchIndex === match.globalMatchIndex
              ? 'border-blue-400 bg-blue-50'
              : 'border-gray-200 bg-white',
          )}
        >
          {/* Section badge */}
          <div className="flex items-center gap-1.5 mb-1">
            <span className="text-[10px] font-medium text-blue-700 bg-blue-100 px-1.5 py-0.5 rounded">
              {match.sectionTitle}
            </span>
            <span className="text-[10px] text-gray-400">
              {match.globalMatchIndex + 1}
            </span>
          </div>

          {/* Context snippet - max 2 lines */}
          <p className="text-xs text-gray-700 leading-tight line-clamp-2">
            {highlightMatches(
              match.contextAfter,
              results.query,
              activeMatchIndex,
              results.matches,
              match.sectionIndex,
            )}
          </p>
        </button>
      ))}
    </div>
  );
};
